export default "__VITE_ASSET__D6TJvrg0__"